import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type State = {
	message: {
		visible: boolean;
		text: string;
	};
};

const INITIAL_STATE: State = {
	message: {
		visible: false,
		text: '',
	},
};

export const tmpSlice = createSlice({
	name: 'tmp',
	initialState: INITIAL_STATE,
	reducers: {
		showMessage: (state, action: PayloadAction<string>) => {
			state.message.text = action.payload;
			state.message.visible = true;
		},
		hideMessage: (state) => {
			state.message.visible = false;
		},
	},
});
